import _ from 'lodash';
import {TRIM} from '../constants/actionTypes';
import initial from './initialState';

export default function (state = initial.trimState, action) {
  switch (action.type) {
    case TRIM.GET_LIST_SUCCESS:
      return {...state, items: action.data.items || [], count: action.data.count || 0};
    case TRIM.RELOAD:
      return {...state, reload: !state.reload};
    case TRIM.GET_DETAIL_SUCCESS:
      return {...state, detail: action.data};
    case TRIM.RESET_DETAIL:
      return {...state, detail: {}};
    case TRIM.GET_KEY_SUCCESS: {
      let properties = _.cloneDeep(state.properties);
      if (!_.isEmpty(action.data) && action.data.key) {
        _.set(properties, action.data.key, action.data.values || []);
      }
      return {...state, properties: properties};
    }
    default:
      return state;
  }
}
